import "./SupplyQuote.module.css";
import GlobalNavigation from "@/reusable_sections/Header";
import ProcurementRequirements from "./sections/ProcurementRequirements";
import ServiceCommitments from "./sections/ServiceCommitments";
import Footer from "@/reusable_sections/Footer";
export default function SupplyQuotePage() {
  return <div>
      <GlobalNavigation />
      <ProcurementRequirements />
      <ServiceCommitments />
      <Footer />
    </div>;
}